import gql from 'graphql-tag';

export const ACTIVITY_BOOKING = gql`
  query activitiesBookings(
    $activityBookingId: Int
    $businessOwnerId: Int
    $token: String
  ) {
    activitiesBookings(
      activityBookingId: $activityBookingId
      businessOwnerId: $businessOwnerId
      token: $token
    ) {
      id
      activity {
        id
        title
        photo
        productCode
        isOpen
        minParticipants
        maxParticipants
        startingPoint
        pricesType
        futurePriceForm
        scheduleType
        cancellation
        cancellationNo
        prices {
          id
          participant {
            participant
          }
          currency {
            currency
          }
          days
          value
        }
        futurePrices {
          id
          ratePlan {
            id
            title
          }
          ratePlanPrices {
            id
            value
            currency {
              currency
            }
            participant {
              participant
            }
            startDate
            endDate
          }
        }
        activitybookingSet {
          deactivationBooking
          id
          isCanceled
        }
      }
      isCanceled
      guestFirstName
      guestLastName
      guestPhoneNumber
      guestEmail
      platform
      startingDate
      endingDate
      schedule
      payments {
        id
        paymentType
        currency {
          currency
        }
        totalPrice
      }
      bookedAddOns {
        id
        addOn {
          id
          title
          titleNo
          description
          descriptionNo
          prices {
            participant {
              participant
            }
            currency {
              currency
            }
            value
          }
        }
        currency {
          currency
        }
        addOnCount
        totalPrice
      }
      guests {
        participant {
          participant
        }
        guestsNumber
        totalPrice
      }

      relatedAccommodationBooking {
        id
        accommodation {
          id
          title
          titleNo
          guestsNumber
          prices {
            id
            participant {
              participant
            }
            currency {
              currency
            }
            value
            day
          }
          futurePrices {
            id
            ratePlan {
              id
              title
            }
            ratePlanPrices {
              id
              value
              currency {
                currency
              }
              startDate
              endDate
            }
          }
        }
        platform
        fromDate
        toDate
        payments {
          paymentType
          currency {
            currency
          }
          totalPrice
        }
        bookedAddOns {
          id
          addOn {
            id
            title
            titleNo
            description
            descriptionNo
            prices {
              participant {
                participant
              }
              currency {
                currency
              }
              value
            }
          }
          currency {
            currency
          }
          addOnCount
          totalPrice
        }
        bookedMandatoryFees {
          id
          mandatoryFee {
            id
            title
            titleNo
            description
            descriptionNo
            prices {
              currency {
                currency
              }
              value
            }
          }
          currency {
            currency
          }
          mandatoryFeeCount
          totalPrice
        }
        guests {
          participant {
            participant
          }
          guestsNumber
          totalPrice
        }
      }
    }
  }
`;
